(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["horse-person-landing"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var btn = document.getElementById("hp-copy-btn");
    var msg = document.getElementById("hp-copied-msg");
    if (!btn) return;
    btn.addEventListener("click", function() {
      var code = btn.textContent.trim();
      navigator.clipboard.writeText(code).then(function() {
        msg.classList.add("visible");
        setTimeout(function() { msg.classList.remove("visible"); }, 2000);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-boot-up"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.hp-bu').forEach(root=>{
 const form=root.querySelector('form'),grid=root.querySelector('.hp-bu-grid'),cards=Array.from(grid.children),status=root.querySelector('.hp-bu-status');
 if(root.querySelector('.hp-bu-pagination a'))return;
 const field=name=>form.elements.namedItem(name);
 function update(){const q=field('q').value.trim().toLowerCase(),category=field('category').value,stock=field('stock').checked,sort=field('sort').value;let count=0;const ordered=cards.slice();if(sort!=='default')ordered.sort((a,b)=>(Number(a.dataset.price)-Number(b.dataset.price))*(sort==='low'?1:-1));ordered.forEach(card=>{card.hidden=!(card.dataset.title.toLowerCase().includes(q)&&(category==='all'||card.dataset.category.split(' ').includes(category))&&(!stock||card.dataset.stock==='true'));if(!card.hidden)count++;grid.append(card);});status.textContent=count?status.dataset.results.replace('[count]',count):status.dataset.empty;}
 form.hidden=false;form.addEventListener('input',update);form.addEventListener('change',update);form.addEventListener('submit',event=>event.preventDefault());form.addEventListener('reset',()=>setTimeout(update,0));update();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-fall-bundles"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.hp-fb').forEach(root=>{
 const form=root.querySelector('form'),grid=root.querySelector('.hp-fb-grid'),cards=Array.from(grid.children),status=root.querySelector('.hp-fb-status');
 if(root.querySelector('.hp-fb-pagination a'))return;
 const field=name=>form.elements.namedItem(name);
 function update(){const q=field('q').value.trim().toLowerCase(),category=field('category').value,stock=field('stock').checked,sort=field('sort').value;let count=0;const ordered=cards.slice();if(sort!=='default')ordered.sort((a,b)=>(Number(a.dataset.price)-Number(b.dataset.price))*(sort==='low'?1:-1));ordered.forEach(card=>{card.hidden=!(card.dataset.title.toLowerCase().includes(q)&&(category==='all'||card.dataset.category.split(' ').includes(category))&&(!stock||card.dataset.stock==='true'));if(!card.hidden)count++;grid.append(card);});status.textContent=count?status.dataset.results.replace('[count]',count):status.dataset.empty;}
 form.hidden=false;form.addEventListener('input',update);form.addEventListener('change',update);form.addEventListener('submit',event=>event.preventDefault());form.addEventListener('reset',()=>setTimeout(update,0));update();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-halloween"] && !Shopify.designMode) return;
  try {
    
(async function(){
const root=document.querySelector('.hp-hw');if(!root||root.dataset.ready)return;root.dataset.ready='true';
const form=root.querySelector('.hp-hw-filter'),grid=root.querySelector('.hp-hw-grid'),status=root.querySelector('.hp-hw-status'),pagination=root.querySelector('.hp-hw-pagination');
let next=pagination.dataset.next;const visited=new Set();
try{while(next){if(visited.has(next))throw new Error('Repeated page');visited.add(next);status.textContent=status.dataset.loading;const url=new URL(next,location.href);url.searchParams.set('section_id',root.dataset.section);const current=new URL(location.href);for(const key of ['preview_theme_id','view']){if(current.searchParams.has(key))url.searchParams.set(key,current.searchParams.get(key));}const response=await fetch(url);if(!response.ok)throw new Error('Collection unavailable');const doc=new DOMParser().parseFromString(await response.text(),'text/html');const incoming=doc.querySelectorAll('.hp-hw-card');if(!incoming.length)throw new Error('No products');incoming.forEach(card=>{if(!grid.querySelector('[data-id="'+card.dataset.id+'"]'))grid.append(card);});next=doc.querySelector('.hp-hw-pagination')?.dataset.next||'';}}
catch(error){status.textContent=status.dataset.error;return;}
const cards=Array.from(grid.querySelectorAll('.hp-hw-card'));cards.forEach((card,index)=>card.dataset.index=index);
let group='all';
function apply(){const q=form.elements.q.value.trim().toLowerCase(),sort=form.elements.sort.value,stock=form.elements.available.checked;let count=0;cards.sort((a,b)=>sort==='low'?+a.dataset.price-+b.dataset.price:sort==='high'?+b.dataset.price-+a.dataset.price:+a.dataset.index-+b.dataset.index);cards.forEach(card=>{card.hidden=!(card.dataset.groups.includes('|'+group+'|')&&card.dataset.title.toLowerCase().includes(q)&&(!stock||card.dataset.available==='true'));if(!card.hidden)count++;grid.append(card);});status.textContent=count?count+' '+(count===1?status.dataset.single:status.dataset.results):status.dataset.empty;root.querySelectorAll('[data-group]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.group===group)));}
root.querySelectorAll('[data-group]').forEach(button=>button.addEventListener('click',()=>{group=button.dataset.group;apply();}));
root.querySelectorAll('[data-pick]').forEach(link=>link.addEventListener('click',()=>{group=link.dataset.pick;form.elements.q.value='';apply();}));
form.addEventListener('input',apply);form.addEventListener('change',apply);form.addEventListener('submit',e=>e.preventDefault());form.addEventListener('reset',()=>{group='all';setTimeout(apply,0);});form.hidden=false;pagination.hidden=true;apply();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-myler-intent"] && !Shopify.designMode) return;
  try {
    
(async function(){
const root=document.querySelector('.hp-mi');if(!root)return;
const grid=root.querySelector('.hp-mi-grid'),form=root.querySelector('form'),status=root.querySelector('.hp-mi-status'),pagination=root.querySelector('.hp-mi-pagination');
status.textContent=status.dataset.loading;
let next=root.querySelector('.hp-mi-next'),seen=new Set(Array.from(grid.children).map(c=>c.dataset.id)),visited=new Set();
try{
while(next){
const url=new URL(next.getAttribute('href'),location.href);url.searchParams.set('section_id',root.dataset.section);
const current=new URL(location.href);for(const key of ['view','preview_theme_id'])if(current.searchParams.has(key))url.searchParams.set(key,current.searchParams.get(key));
if(visited.has(url.href))throw Error('pagination');visited.add(url.href);
const response=await fetch(url);if(!response.ok)throw Error('load');
const doc=new DOMParser().parseFromString(await response.text(),'text/html'),newGrid=doc.querySelector('.hp-mi-grid');if(!newGrid)throw Error('content');
for(const card of newGrid.children)if(!seen.has(card.dataset.id)){seen.add(card.dataset.id);grid.append(card.cloneNode(true));}
next=doc.querySelector('.hp-mi-next');
}
}catch(e){status.textContent=status.dataset.error;return;}
const cards=Array.from(grid.children);
function sizeValue(s){
const value=s.toLowerCase().replace(/[“”″]/g,'"').replace(/['’]{2}/g,'"').replace(/½/g,' 1/2').replace(/¾/g,' 3/4').replace(/¼/g,' 1/4').replace(/\s*\/\s*/g,'/').replace(/\s*(?:inches|inch|in\.?|")\s*$/,'').replace(/-/g,' ').trim().replace(/\s+/g,' ');
const m=value.match(/^(\d+(?:\.\d+)?)(?:\s+([1-3])\/([24]))?$/);
if(!m||m[2]&&(m[1].includes('.')||Number(m[2])>=Number(m[3])))return '';
const n=Number(m[1])+(m[2]?Number(m[2])/Number(m[3]):0);
return n>0?String(n):'';
}
function sizeLabel(value){
const n=Number(value),whole=Math.floor(n),fraction={'0.25':'¼','0.5':'½','0.75':'¾'}[String(n-whole)];
return (fraction?String(whole)+fraction:value)+'″';
}
cards.forEach((card,i)=>{
const t=card.dataset.title.toLowerCase();
card._index=i;
card._cheek=/curb chain|curb strap|j hooks|spurs/.test(t)?'Accessories':/combination|combo/.test(t)?'Combination':/baucher/.test(t)?'Baucher':/eggbutt/.test(t)?'Eggbutt':/loose ring|bridoon/.test(t)?'Loose ring / Bridoon':/full cheek/.test(t)?'Full cheek':/kimberwick/.test(t)?'Kimberwick':/shank|curb bit/.test(t)?'Shank':/dee|d-ring/.test(t)?'Dee':/c-sleeve/.test(t)?'C-sleeve':'Other / Not listed';
card._codes=Array.from(card.dataset.title.toUpperCase().matchAll(/\bMB\s*(\d{2}(?:-\d|[A-Z]{1,2})?)/g),m=>m[1]);
card._sizes=card.dataset.sizes.split('|').filter(Boolean).map(sizeValue).filter(Boolean);
if(!card._sizes.length){const m=t.match(/(\d+(?:\s+[1-3]\/[24]|\.\d+)?)\s*(?:"|inch|inches|-inch)\s*(?:mouth|horse bit)/);if(m)card._sizes=[sizeValue(m[1])].filter(Boolean);}
});
for(const [field,values] of [['cheek',cards.map(c=>c._cheek)],['code',cards.flatMap(c=>c._codes)],['size',cards.flatMap(c=>c._sizes)]]){
const select=form.elements[field];Array.from(new Set(values)).sort((a,b)=>field==='size'?Number(a)-Number(b):a.localeCompare(b,undefined,{numeric:true})).forEach(v=>{const option=document.createElement('option');option.value=v;option.textContent=field==='code'?'MB '+v:field==='size'?sizeLabel(v):v;select.append(option);});
}
function apply(){
const q=form.elements.q.value.trim().toLowerCase(),cheek=form.elements.cheek.value,code=form.elements.code.value,size=form.elements.size.value,stock=form.elements.stock.value,sort=form.elements.sort.value;
let count=0;cards.sort((a,b)=>sort==='low'?Number(a.dataset.price)-Number(b.dataset.price):sort==='high'?Number(b.dataset.price)-Number(a.dataset.price):a._index-b._index);
cards.forEach(c=>{c.hidden=!(c.dataset.title.toLowerCase().includes(q)&&(!cheek||c._cheek===cheek)&&(!code||c._codes.includes(code))&&(!size||c._sizes.includes(size))&&(!stock||c.dataset.available==='true'));if(!c.hidden)count++;grid.append(c);});
status.textContent=count?count+' '+status.dataset.results:status.dataset.empty;
}
form.hidden=false;pagination.hidden=true;apply();form.addEventListener('input',apply);form.addEventListener('change',apply);form.addEventListener('submit',e=>e.preventDefault());form.addEventListener('reset',()=>setTimeout(apply,0));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  class SortByHandler extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('.disclosure__link').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.button.innerHTML = event.target.dataset.name;
      event.target.closest('ul').querySelector('.animation-underline--active').classList.remove("animation-underline--active");
      event.target.classList.add("animation-underline--active");
      if(document.getElementById('SortBy')){
        document.getElementById('SortBy').value = event.target.dataset.value;
        document.getElementById('FacetFiltersForm').dispatchEvent(new Event('input'));
      }
      else{
        document.getElementById('SortBy-mobile').value = event.target.dataset.value;
        document.getElementById('FacetFiltersFormMobile').dispatchEvent(new Event('input'));
      }
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      var _this = this;
      setTimeout(function(){_this.hidePanel();}, 150)
    }
  }

  customElements.define('sort-by-select', SortByHandler);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    }

    if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  class SortByHandler extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('.disclosure__link').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.button.innerHTML = event.target.dataset.name;
      event.target.closest('ul').querySelector('.animation-underline--active').classList.remove("animation-underline--active");
      event.target.classList.add("animation-underline--active");
      document.getElementById('SortBy').value = event.target.dataset.value;
      document.getElementById('FacetFiltersForm').dispatchEvent(new Event('input'));
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      var _this = this;
      setTimeout(function(){_this.hidePanel();}, 150)
    }
  }

  customElements.define('sort-by-select', SortByHandler);

  } catch(e) { console.error(e); }
})();
})();
